import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login, getTokenPayload } from "../services/authService";
import API_BASE_URL from '../config';
import '../styles/auth.css';

export default function Login() {
  const [mode, setMode] = useState('login'); // 'login' or 'register'
  const navigate = useNavigate();

  // login fields
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(false);

  // register fields
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [file, setFile] = useState(null);
  const [regEmail, setRegEmail] = useState('');
  const [regPassword, setRegPassword] = useState('');
  const [regConfirmPassword, setRegConfirmPassword] = useState('');
  const [regUsername, setRegUsername] = useState('');
  const [regPhoneNumber, setRegPhoneNumber] = useState('');
  const [regAcceptTerms, setRegAcceptTerms] = useState(false);
  const [regCountry, setRegCountry] = useState('');
  const [regStateProvince, setRegStateProvince] = useState('');
  const [regCity, setRegCity] = useState('');
  const [regZip, setRegZip] = useState('');
  const [regStreetAddress, setRegStreetAddress] = useState('');
  const [regDateOfBirth, setRegDateOfBirth] = useState('');
  const [regGender, setRegGender] = useState('');
  const [regMarketingEmail, setRegMarketingEmail] = useState(false);
  const [regMarketingSMS, setRegMarketingSMS] = useState(false);
  const [regPreferredCurrency, setRegPreferredCurrency] = useState('ALL');
  const [message, setMessage] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  const apiRoot = API_BASE_URL.replace(/\/api\/?$/, '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await login(email, password);
      if (res && res.token) {
        const payload = getTokenPayload();
        if (payload && payload.role === 'admin') navigate('/admin');
        else navigate('/');
      } else {
        setError(res?.message || "Të dhëna të pasakta");
      }
    } catch (err) {
      setError("Kyçja dështoi");
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setMessage('');
    setValidationErrors({});
    const errs = {};
    const vUsername = (regUsername || '').trim();
    const vName = (name || '').trim();
    const vSurname = (surname || '').trim();
    const vEmail = (regEmail || '').trim();
    const vPassword = regPassword || '';
    const vConfirm = regConfirmPassword || '';
    const vPhone = (regPhoneNumber || '').trim();
    const vAccept = (regAcceptTerms === true || regAcceptTerms === 'true');

    if (!vUsername) errs.username = 'Username is required';
    if (!vName) errs.name = 'First name is required';
    if (!vSurname) errs.surname = 'Last name is required';
    if (!vEmail) errs.email = 'Email is required';
    else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(vEmail)) errs.email = 'Invalid email';
    if (!vPassword) errs.password = 'Password is required';
    if (!vConfirm) errs.confirmPassword = 'Please confirm password';
    if (vPassword && vConfirm && vPassword !== vConfirm) errs.confirmPassword = 'Passwords do not match';
    if (!vPhone) errs.phoneNumber = 'Phone number is required';
    if (!vAccept) errs.acceptTerms = 'You must accept terms and conditions';
    if (Object.keys(errs).length) {
      setValidationErrors(errs);
      console.warn('In-page register validation errors:', errs);
      const labels = Object.keys(errs).map(k => errs[k]);
      setMessage('Please fix highlighted fields: ' + labels.join('; '));
      setTimeout(() => {
        const first = document.querySelector('.input-invalid');
        if (first && typeof first.focus === 'function') first.focus();
      }, 20);
      return;
    }
    try {
      const fd = new FormData();
      fd.append('name', name);
      fd.append('surname', surname);
      fd.append('username', regUsername);
      fd.append('email', regEmail);
      fd.append('password', regPassword);
      fd.append('confirmPassword', regConfirmPassword);
      fd.append('phoneNumber', regPhoneNumber);
      fd.append('acceptTerms', regAcceptTerms);
      fd.append('country', regCountry);
      fd.append('stateProvince', regStateProvince);
      fd.append('city', regCity);
      fd.append('zip', regZip);
      fd.append('streetAddress', regStreetAddress);
      if (regDateOfBirth) fd.append('dateOfBirth', regDateOfBirth);
      if (regGender) fd.append('gender', regGender);
      fd.append('marketingEmail', regMarketingEmail);
      fd.append('marketingSMS', regMarketingSMS);
      fd.append('preferredCurrency', regPreferredCurrency);
      if (file) fd.append('profileImage', file);

      const res = await fetch(`${apiRoot}/api/auth/register`, {
        method: 'POST',
        credentials: 'include',
        body: fd,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setMessage(data.message || 'Registration failed');
        return;
      }
      if (data.token) {
        localStorage.setItem('token', data.token);
        const payload = getTokenPayload();
        if (payload && payload.role === 'admin') navigate('/admin');
        else navigate('/');
      } else {
        setMessage(data.message || 'Registered');
      }
    } catch (err) {
      console.error(err);
      setMessage('Registration failed');
    }
  };



  return (
    <div className="auth-page">
      <div className={`auth-card ${mode === 'register' ? 'auth-card-wide' : ''}`}>
        <div className="auth-icon-badge">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
        <h2 className="auth-title">{mode === 'login' ? 'Mirë se erdhët' : 'Krijo Llogari'}</h2>
        <p className="auth-sub">{mode === 'login' ? 'Ju lutem shënoni të dhënat tuaja për t\'u kyçur.' : 'Plotësoni të dhënat për t\'u regjistruar në Globe.'}</p>

        {mode === 'login' ? (
          <form onSubmit={handleSubmit} className="auth-form">
            <div>
              <input 
                className="auth-input" 
                placeholder="Email ose përdoruesi" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                autoFocus
              />
            </div>
            <div className="password-row">
              <input 
                className="auth-input" 
                placeholder="Fjalëkalimi" 
                type={showPassword ? 'text' : 'password'} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
              />
              <button 
                type="button" 
                className="eye-btn" 
                onClick={() => setShowPassword(s => !s)}
                aria-label={showPassword ? "Fshih fjalëkalimin" : "Shfaq fjalëkalimin"}
              >
                {showPassword ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                    <line x1="1" y1="1" x2="23" y2="23" />
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>

            <div className="auth-helpers">
              <label className="remember"><input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} /> Më mbaj mend</label>
              <Link to="/forgot" className="forgot">Keni harruar fjalëkalimin?</Link>
            </div>

            <button type="submit" className="auth-submit">Kyçu</button>
            {error ? (
              <div className="auth-error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <span>{error}</span>
              </div>
            ) : null}
            <div className="auth-footer">
              Nuk keni llogari akoma?{' '}
              <button type="button" className="auth-link-btn" onClick={() => setMode('register')}>
                Regjistrohuni
              </button>
            </div>
          </form>
        ) : (
          <form onSubmit={handleRegister} className="auth-form">
            <div>
              <label className="required-label">Username</label>
              <input className={`auth-input ${validationErrors.username ? 'input-invalid' : ''}`} placeholder="Username" value={regUsername} onChange={e => setRegUsername(e.target.value)} />
              {validationErrors.username && <div className="field-error">{validationErrors.username}</div>}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <div style={{ flex: 1 }}>
                <label className="required-label">First name</label>
                <input className={`auth-input ${validationErrors.name ? 'input-invalid' : ''}`} placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
                {validationErrors.name && <div className="field-error">{validationErrors.name}</div>}
              </div>
              <div style={{ flex: 1 }}>
                <label className="required-label">Last name</label>
                <input className={`auth-input ${validationErrors.surname ? 'input-invalid' : ''}`} placeholder="Surname" value={surname} onChange={e => setSurname(e.target.value)} />
                {validationErrors.surname && <div className="field-error">{validationErrors.surname}</div>}
              </div>
            </div>
            <div>
              <label className="required-label">Email</label>
              <input className={`auth-input ${validationErrors.email ? 'input-invalid' : ''}`} placeholder="Email" value={regEmail} onChange={e => setRegEmail(e.target.value)} />
              {validationErrors.email && <div className="field-error">{validationErrors.email}</div>}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <div style={{ flex: 1 }}>
                <label className="required-label">Password</label>
                <input className={`auth-input ${validationErrors.password ? 'input-invalid' : ''}`} placeholder="Password" type={showPassword ? 'text' : 'password'} value={regPassword} onChange={e => setRegPassword(e.target.value)} />
                {validationErrors.password && <div className="field-error">{validationErrors.password}</div>}
              </div>
              <div style={{ flex: 1 }}>
                <label className="required-label">Confirm password</label>
                <input className={`auth-input ${validationErrors.confirmPassword ? 'input-invalid' : ''}`} placeholder="Confirm password" type="password" value={regConfirmPassword} onChange={e => setRegConfirmPassword(e.target.value)} />
                {validationErrors.confirmPassword && <div className="field-error">{validationErrors.confirmPassword}</div>}
              </div>
            </div>
            <div>
              <label className="required-label">Phone (+country code)</label>
              <input className={`auth-input ${validationErrors.phoneNumber ? 'input-invalid' : ''}`} placeholder="Phone (+country code)" value={regPhoneNumber} onChange={e => setRegPhoneNumber(e.target.value)} />
              {validationErrors.phoneNumber && <div className="field-error">{validationErrors.phoneNumber}</div>}
            </div>
            <div>
              <label className="required-label">Street address</label>
              <input className="auth-input" placeholder="Street address" value={regStreetAddress} onChange={e => setRegStreetAddress(e.target.value)} />
            </div>
            <div>
              <label>City</label>
              <input className="auth-input" placeholder="City" value={regCity} onChange={e => setRegCity(e.target.value)} />
            </div>
            <div>
              <label>State / Province</label>
              <input className="auth-input" placeholder="State / Province" value={regStateProvince} onChange={e => setRegStateProvince(e.target.value)} />
            </div>
            <div>
              <label>ZIP / Postal code</label>
              <input className="auth-input" placeholder="ZIP / Postal code" value={regZip} onChange={e => setRegZip(e.target.value)} />
            </div>
            <div>
              <label>Country</label>
              <input className="auth-input" placeholder="Country" value={regCountry} onChange={e => setRegCountry(e.target.value)} />
            </div>
            <div style={{ marginTop: 8 }}>
              <label>Data e lindjes <input type="date" value={regDateOfBirth} onChange={e => setRegDateOfBirth(e.target.value)} /></label>
              <label>Gjinia <select value={regGender} onChange={e => setRegGender(e.target.value)}>
                <option value="">Preferoj të mos them</option>
                <option value="female">Femër</option>
                <option value="male">Mashkull</option>
                <option value="other">Tjetër</option>
              </select></label>
            </div>
            <div style={{ marginTop: 8 }}>
              <label><input type="checkbox" checked={regMarketingEmail} onChange={e => setRegMarketingEmail(e.target.checked)} /> Email-e marketingu</label>
              <label style={{ marginLeft: 8 }}><input type="checkbox" checked={regMarketingSMS} onChange={e => setRegMarketingSMS(e.target.checked)} /> SMS marketingu</label>
            </div>
            <label style={{ display: 'block', marginTop: 8 }}>
              Valuta e preferuar
              <select className="auth-input" value={regPreferredCurrency} onChange={e => setRegPreferredCurrency(e.target.value)}>
                <option value="ALL">ALL (Lokale)</option>
                <option value="EUR">EUR</option>
                <option value="USD">USD</option>
              </select>
            </label>
            <label className="file-label">Foto profili (opsionale)
              <input type="file" accept="image/*" onChange={e => setFile(e.target.files?.[0] || null)} />
            </label>
            <label style={{ display: 'block', marginTop: 8 }}>
              <input type="checkbox" checked={regAcceptTerms} onChange={e => setRegAcceptTerms(e.target.checked)} /> Pranoj termat dhe kushtet
            </label>
            <button type="submit" className="auth-submit">Krijo llogari</button>
            <div className="auth-footer">
              Keni tashmë një llogari?{' '}
              <button type="button" className="auth-link-btn" onClick={() => setMode('login')}>
                Kyçu
              </button>
            </div>
            {message ? <div className="auth-message">{message}</div> : null}
          </form>
        )}
      </div>
    </div>
  );
}
